export default "__VITE_ASSET__ef622a2d__"